import React from 'react';

const Nav = ({ onClose }) => {
    const handleClick = () => {
        if (onClose) onClose();
    };

    return (
        <ul className="mainmenu">
            <li><a href="/" onClick={handleClick}>Home</a></li>
            <li><a href="/#pricing" onClick={handleClick}>Oferta</a></li>
            <li><a href="/#pricing" onClick={handleClick}>Cennik</a></li>
            <li><a href="/#contact" onClick={handleClick}>Kontakt</a></li>
        </ul>
    );
};

export default Nav;
